import { render, staticRenderFns } from "./TextAssgntsModal.vue?vue&type=template&id=3b239054&"
import script from "./TextAssgntsModal.vue?vue&type=script&lang=js&"
export * from "./TextAssgntsModal.vue?vue&type=script&lang=js&"
import style0 from "./TextAssgntsModal.vue?vue&type=style&index=0&id=3b239054&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports